(function () {
  function initFcUpsell(root) {
    if (!root || root.dataset.fcUpsellInitialized === 'true') return;

    root.dataset.fcUpsellInitialized = 'true';

    var productRoot = root.closest('[data-product-root]');
    if (!productRoot) return;

    var currentHandle = root.dataset.currentHandle || '';
    var currentTitle = root.dataset.currentTitle || '';

    var loadingEl = root.querySelector('[data-upsell-loading]');
    var contentEl = root.querySelector('[data-upsell-content]');
    var imageEl = root.querySelector('[data-upsell-image]');
    var titleEl = root.querySelector('[data-upsell-title]');
    var weightEl = root.querySelector('[data-upsell-weight]');
    var reasonEl = root.querySelector('[data-upsell-reason]');
    var priceEl = root.querySelector('[data-upsell-price]');
    var selectWrap = root.querySelector('[data-upsell-variant-wrap]');
    var selectEl = root.querySelector('[data-upsell-select]');
    var addButton = root.querySelector('[data-upsell-add]');
    var messageEl = root.querySelector('[data-upsell-message]');

    var productCache = {};
    var currentRecommendation = null;
    var currentUpsellVariant = null;

    var RULES = {
      'bravura-brasilera': {
        '300': {
          handle: 'cumbre-dulce',
          targetWeight: '300',
          displayWeight: '300 g',
          standalone: false,
          reason: 'Prueba un perfil más afrutado y aromático'
        },

        '500': {
          handle: 'eunoia',
          targetWeight: '300',
          displayWeight: '300 g',
          standalone: false,
          reason: 'Añade un café diferente para alternar'
        },

        '1000': {
          handle: '150gr-cumbre-dulce-de-colombia',
          displayWeight: '150 g',
          standalone: true,
          reason: 'Prueba otro origen en formato pequeño'
        }
      },

      'eunoia': {
        '300': {
          handle: 'bravura-brasilera',
          targetWeight: '300',
          displayWeight: '300 g',
          standalone: false,
          reason: 'Combínalo con un café más achocolatado'
        },

        '500': {
          handle: 'cumbre-dulce',
          targetWeight: '300',
          displayWeight: '300 g',
          standalone: false,
          reason: 'Añade un perfil más frutal y aromático'
        },

        '1000': {
          handle: '150gr-bravura-brasilera-de-brasil',
          displayWeight: '150 g',
          standalone: true,
          reason: 'Prueba algo más dulce y achocolatado'
        }
      },

      'cumbre-dulce': {
        '300': {
          handle: 'eunoia',
          targetWeight: '300',
          displayWeight: '300 g',
          standalone: false,
          reason: 'Prueba un perfil avainillado y más intenso'
        },

        '500': {
          handle: 'bravura-brasilera',
          targetWeight: '300',
          displayWeight: '300 g',
          standalone: false,
          reason: 'Añade un café más dulce y fácil de beber'
        },

        '1000': {
          handle: '150gr-eunoia-de-ruanda',
          displayWeight: '150 g',
          standalone: true,
          reason: 'Descubre otro perfil en formato pequeño'
        }
      },

      'inner-fire': {
        '300': {
          handle: 'bravura-brasilera',
          targetWeight: '300',
          displayWeight: '300 g',
          standalone: false,
          reason: 'Combínalo con un perfil más dulce'
        },

        '500': {
          handle: 'cumbre-dulce',
          targetWeight: '300',
          displayWeight: '300 g',
          standalone: false,
          reason: 'Añade un café más aromático y afrutado'
        },

        '1000': {
          handle: '150gr-eunoia-de-ruanda',
          displayWeight: '150 g',
          standalone: true,
          reason: 'Prueba otro perfil en una bolsa pequeña'
        }
      },

      'chocombia-decaf': {
        '300': {
          handle: 'bravura-brasilera',
          targetWeight: '300',
          displayWeight: '300 g',
          standalone: false,
          reason: 'Añade una opción con cafeína, dulce y achocolatada'
        },

        '500': {
          handle: 'eunoia',
          targetWeight: '300',
          displayWeight: '300 g',
          standalone: false,
          reason: 'Prueba un perfil más intenso y aromático'
        },

        '1000': {
          handle: '150gr-cumbre-dulce-de-colombia',
          displayWeight: '150 g',
          standalone: true,
          reason: 'Descubre un café afrutado en formato pequeño'
        }
      }
    };

    function normalize(text) {
      return String(text || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    }

    function detectWeight(title) {
      var text = normalize(title);

      if (
        text.indexOf('1000') !== -1 ||
        text.indexOf('1 kg') !== -1 ||
        text.indexOf('1kg') !== -1 ||
        text.indexOf('1 kilo') !== -1
      ) {
        return '1000';
      }

      if (text.indexOf('500') !== -1) return '500';
      if (text.indexOf('300') !== -1) return '300';
      if (text.indexOf('150') !== -1) return '150';

      return null;
    }

    function findCurrentVariant() {
      var variantIdInput = productRoot.querySelector('[data-variant-id]');
      var variantSelect = productRoot.querySelector('[data-variant-select]');

      if (!variantIdInput || !variantSelect) return null;

      var variantId = String(variantIdInput.value);

      var option = Array.from(variantSelect.options).find(function (item) {
        return String(item.value) === variantId;
      });

      if (!option) return null;

      return {
        id: variantId,
        title: option.textContent.trim()
      };
    }

    function getRecommendation() {
      var currentVariant = findCurrentVariant();

      var titleNormalized = normalize(currentTitle);
      var handleNormalized = normalize(currentHandle);

      if (
        titleNormalized.indexOf('degust') !== -1 ||
        handleNormalized.indexOf('degust') !== -1
      ) {
        return {
          handle: 'inner-fire',
          targetWeight: '300',
          displayWeight: '300 g',
          standalone: false,
          reason: '¿Ya has probado varios? Sigue con un café diferente'
        };
      }

      if (!currentVariant) return null;

      var weight = detectWeight(currentVariant.title);

      if (!weight) return null;

      var productRules = RULES[currentHandle];

      if (!productRules || !productRules[weight]) return null;

      return productRules[weight];
    }

    async function fetchProduct(handle) {
      if (productCache[handle]) {
        return productCache[handle];
      }

      var response = await fetch('/products/' + handle + '.js', {
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error('No se pudo cargar el producto recomendado.');
      }

      var product = await response.json();

      productCache[handle] = product;

      return product;
    }

    function variantMatchesWeight(variant, weight) {
      return detectWeight(variant.title) === weight;
    }

    function getAvailableVariants(product, recommendation) {
      if (recommendation.standalone) {
        return product.variants.filter(function (variant) {
          return variant.available;
        });
      }

      return product.variants.filter(function (variant) {
        return (
          variant.available &&
          variantMatchesWeight(
            variant,
            recommendation.targetWeight
          )
        );
      });
    }

    function formatMoney(cents) {
      try {
        return new Intl.NumberFormat('es-ES', {
          style: 'currency',
          currency: 'EUR'
        }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2).replace('.', ',') + ' €';
      }
    }

    function cleanVariantTitle(title, recommendation) {
      var cleaned = String(title || '');

      if (!recommendation.standalone) {
        var weight = recommendation.targetWeight;

        var patterns = [
          weight + ' gramos',
          weight + ' gr',
          weight + 'g',
          weight + ' g'
        ];

        patterns.forEach(function (pattern) {
          cleaned = cleaned.replace(
            new RegExp(pattern, 'ig'),
            ''
          );
        });
      }

      cleaned = cleaned
        .replace(/^\s*[-/·|]\s*/, '')
        .replace(/\s*[-/·|]\s*$/, '')
        .trim();

      return cleaned || title;
    }

    function cleanProductTitle(title) {
      return String(title || '')
        .replace(/^150\s*gr\s*/i, '')
        .replace(/^150\s*g\s*/i, '')
        .replace(/^150\s*gramos\s*/i, '')
        .trim();
    }

    function setCurrentVariant(variant) {
      currentUpsellVariant = variant;

      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
      }
    }

    function populateSelect(variants, recommendation) {
      selectEl.innerHTML = '';

      variants.forEach(function (variant) {
        var option = document.createElement('option');

        option.value = variant.id;

        option.textContent = cleanVariantTitle(
          variant.title,
          recommendation
        );

        selectEl.appendChild(option);
      });

      selectWrap.hidden = variants.length <= 1;

      setCurrentVariant(variants[0]);
    }

    function hideUpsell() {
      root.hidden = true;
    }

    function showMessage(text, isError) {
      if (!messageEl) return;

      messageEl.hidden = false;
      messageEl.textContent = text;

      messageEl.classList.toggle('is-error', !!isError);
      messageEl.classList.toggle('is-success', !isError);
    }

    function hideMessage() {
      if (!messageEl) return;

      messageEl.hidden = true;
      messageEl.textContent = '';
      messageEl.classList.remove('is-error', 'is-success');
    }

    async function renderRecommendation() {
      hideMessage();

      currentRecommendation = getRecommendation();

      if (!currentRecommendation) {
        hideUpsell();
        return;
      }

      root.hidden = false;
      loadingEl.hidden = false;
      contentEl.hidden = true;

      try {
        var product = await fetchProduct(
          currentRecommendation.handle
        );

        var variants = getAvailableVariants(
          product,
          currentRecommendation
        );

        if (!variants.length) {
          hideUpsell();
          return;
        }

        titleEl.textContent = cleanProductTitle(product.title);

        /*
         * AQUÍ SE MUESTRA SIEMPRE EL GRAMAJE
         */
        if (weightEl) {
          weightEl.textContent =
            currentRecommendation.displayWeight;
        }

        reasonEl.textContent =
          currentRecommendation.reason;

        if (product.featured_image) {
          imageEl.src = product.featured_image;
          imageEl.alt = product.title;
        } else if (product.images && product.images.length) {
          imageEl.src = product.images[0];
          imageEl.alt = product.title;
        }

        populateSelect(
          variants,
          currentRecommendation
        );

        loadingEl.hidden = true;
        contentEl.hidden = false;
      } catch (error) {
        console.error('[Fanatic Upsell]', error);
        hideUpsell();
      }
    }

    function openDrawer() {
      var drawer =
        document.querySelector('cart-drawer-component') ||
        document.querySelector('cart-drawer') ||
        document.querySelector('#CartDrawer') ||
        document.querySelector('.cart-drawer');

      if (!drawer) return false;

      if (typeof drawer.open === 'function') {
        drawer.open();
        return true;
      }

      if (typeof drawer.showDialog === 'function') {
        drawer.showDialog();
        return true;
      }

      return false;
    }

    function dispatchCartUpdate(cart, variantId) {
      var event = new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'fc-product-upsell',
          data: {
            source: 'product-upsell',
            itemCount: cart ? cart.item_count : 1,
            variantId: String(variantId)
          }
        }
      });

      document.dispatchEvent(event);
    }

    if (selectEl) {
      selectEl.addEventListener('change', async function () {
        if (!currentRecommendation) return;

        var product = await fetchProduct(
          currentRecommendation.handle
        );

        var variantId = String(selectEl.value);

        var variant = product.variants.find(function (item) {
          return String(item.id) === variantId;
        });

        if (variant) {
          setCurrentVariant(variant);
        }
      });
    }

    if (addButton) {
      addButton.addEventListener('click', async function () {
        if (!currentUpsellVariant) return;

        hideMessage();

        addButton.disabled = true;
        addButton.textContent = 'Añadiendo...';

        try {
          var response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: currentUpsellVariant.id,
              quantity: 1
            })
          });

          if (!response.ok) {
            throw new Error('No se pudo añadir el producto.');
          }

          await response.json();

          var cartResponse = await fetch('/cart.js', {
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          });

          var cart = cartResponse.ok
            ? await cartResponse.json()
            : null;

          dispatchCartUpdate(
            cart,
            currentUpsellVariant.id
          );

          openDrawer();

          addButton.textContent = 'Añadido ✓';

          setTimeout(function () {
            addButton.disabled = false;
            addButton.textContent = '+ Añadir';
          }, 1300);

        } catch (error) {
          console.error('[Fanatic Upsell]', error);

          showMessage(
            'No se ha podido añadir. Inténtalo de nuevo.',
            true
          );

          addButton.disabled = false;
          addButton.textContent = '+ Añadir';
        }
      });
    }

    productRoot.addEventListener('change', function (event) {
      if (
        event.target.matches(
          '.fc-product__option input, .fc-product__option select'
        )
      ) {
        setTimeout(renderRecommendation, 0);
      }
    });

    renderRecommendation();
  }

  function initAllUpsells() {
    document
      .querySelectorAll('[data-fc-upsell]')
      .forEach(function (root) {
        initFcUpsell(root);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAllUpsells
    );
  } else {
    initAllUpsells();
  }

  document.addEventListener(
    'shopify:section:load',
    initAllUpsells
  );
})();